module.exports = __webpack_public_path__ + "img/Rüstwagen.b87c3e32.svg";